import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UnidadMedida } from '@shared/enums/unidadMedida';
import { TipoProducto } from '@shared/enums/tipoProducto';
import { Producto } from '@shared/models/abm/Producto';
import { ProductoService } from '../producto.service';
import { MessageService } from '@shell/message.service';
import { ProductosListaComponent } from '../productos-lista/productos-lista.component';
import { Rubro } from '@shared/models/abm/Rubro';
import { TipoPrecio } from '@shared/enums/TipoPrecio';
import { NgxSpinnerService } from 'ngx-spinner';
import { TipoCombustible } from '@shared/enums/tipoCombustible';
import { SharedService } from '@shared/shared.service';
import { TipoAerocombustible } from '@shared/enums/tipoAerocombustible';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { TipoServicio, TipoServicioUtil } from '@shared/enums/tipoServicio';
import { ErrorModel } from '@shared/models/ErrorModel';


@Component({
  selector: 'app-informacion',
  templateUrl: './informacion.component.html',
  styleUrls: ['./informacion.component.css']
})
export class InformacionComponent implements OnInit, OnChanges {

  TipoUsuario = TipoUsuario;

  esaero: boolean;
  informacionForm = new UntypedFormGroup({
    codigoFormControl: new UntypedFormControl({value: null, disabled: true}, Validators.required),
    tipoProductoFormControl: new UntypedFormControl({value: null, disabled: true}, Validators.required),
    descripcionFormControl: new UntypedFormControl(null, [Validators.required]),
    activoFormControl: new UntypedFormControl(true),
    unidadMedidaFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    densidadMaximaFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}),
    densidadMinimaFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}),
    porcentajeAlijeFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}),
    tipoPrecioFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    tipoCombustibleFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    tipoAerocombustibleFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    tipoServicioFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}),
    peligrosidadFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    contableFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    partidaFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    productoSAPFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    unidadSAPFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    negocioGerencialFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    unidadStockFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    unidadComercialFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    unidadProduccionFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    grupoEnvaseFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}, [Validators.required]),
    controlCalidadFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}),
    controlStockFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}),
    productoAprobadoFormControl: new UntypedFormControl({value: null, disabled: true}),
    facturaIataFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}),
    aplicatIDCFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.IMPUESTOS)}),
    aplicaITCFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.IMPUESTOS)}),
    impuestoAprobadoFormControl: new UntypedFormControl({value: null, disabled: true}),
    codigoProductoSapFormControl: new UntypedFormControl({value: null, disabled: this.deshabilitarInput(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA)}),
  });
  unidadMedida = UnidadMedida;
  densidadErronea: boolean = false;
  tipoProducto = TipoProducto;
  tipoPrecio = TipoPrecio;
  tipoCombustible = TipoCombustible;
  tipoAerocombustible = TipoAerocombustible;
  tipoServicio = TipoServicio;
  errorRubros: boolean = false;
  modificandoProducto: boolean = false;
  rubros: Rubro[];
  rubroSeleccionado: Rubro;
  cargandoRubros: boolean;
  cargandoInfoProducto: boolean = false;
  @Input() productoSeleccionado: Producto;

  mostrarCampoTipoCombustible: boolean = false;
  mostrarCampoTipoAerocombustible: boolean = false;
  mostrarCampoTipoServicio: boolean = false;

  colores = [
    {
      name: 'NEGRO',
      value: '#000000'
    },
    {
      name: 'ROJO',
      value: '#EF3D42'
    },
    {
      name: 'VERDE',
      value: '#009D57'
    },
    {
      name: 'AMARILLO',
      value: '#FFF200'
    },
    {
      name: 'AZUL',
      value: '#0079C2'
    }
  ];

  selectedColor = '#000000';



  constructor(public authService: AuthService, private productoService: ProductoService, private sharedService: SharedService,
    private messageService: MessageService, private listaDeProductos: ProductosListaComponent, private spinner: NgxSpinnerService) {
  }

  // hooks

  ngOnInit() {
    this.spinner.show('spinnerGrafico');
    this.cargandoRubros = true;
    this.getRubros();
    this.codigo.setValue(this.productoSeleccionado.codigoProducto);
    this.descripcion.setValue(this.productoSeleccionado.nombreProducto);
    this.unidadDeMedida.setValue(this.productoSeleccionado.unidadMedida);
    this.activo.setValue(this.productoSeleccionado.activo);
    this.densidadMaxima.setValue(this.productoSeleccionado.densidadMax);
    this.densidadMinima.setValue(this.productoSeleccionado.densidadMin);
    this.combustible.setValue(this.productoSeleccionado.tipoCombustible);
    this.aerocombustible.setValue(this.productoSeleccionado.tipoAerocombustible);
    console.log(this.productoSeleccionado.tipoAerocombustible);
    this.tipoDePrecio.setValue(this.productoSeleccionado.tipoPrecio);
    this.selectedColor = this.productoSeleccionado.color;


    this.peligrosidad.setValue(this.productoSeleccionado.peligrosidad);
    this.contable.setValue(this.productoSeleccionado.agrupacionContable);
    this.partida.setValue(this.productoSeleccionado.partida);
    this.productoSAP.setValue(this.productoSeleccionado.productoSAP);
    this.unidadSAP.setValue(this.productoSeleccionado.unidadMedidaSAP);
    this.negocioGerencial.setValue(this.productoSeleccionado.unidadNegocioGerencial);
    this.unidadStock.setValue(this.productoSeleccionado.unidadMedidaStock);
    this.unidadComercial.setValue(this.productoSeleccionado.unidadMedidaComercial);
    this.unidadProduccion.setValue(this.productoSeleccionado.unidadMedidaProduccion);
    this.grupoEnvase.setValue(this.productoSeleccionado.grupoEnvase);
    this.controlStock.setValue(this.productoSeleccionado.controlStock);
    this.controlCalidad.setValue(this.productoSeleccionado.controlCalidad);
    this.productoAprobado.setValue(this.productoSeleccionado.aprobadoProducto);
    this.facturaClase3.setValue(this.productoSeleccionado.contabilizaIATANivelDosTres);
    this.aplicaIDC.setValue(this.productoSeleccionado.aplicaIDC);
    this.aplicaITC.setValue(this.productoSeleccionado.aplicaITC);
    this.impuestoAprobado.setValue(this.productoSeleccionado.aprobadoImpuestos);
    this.codigoProductoSap.setValue(this.productoSeleccionado.codigoProductoSAPCompleto);
    this.porcentajeAlije.setValue(this.productoSeleccionado.porcentajeAlije);
    this.servicios.setValue(this.productoSeleccionado.tipoServicio);
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  // llamdas al service

  getRubros() {
    this.cargandoInfoProducto = true;
    this.productoService.getRubros()
      .subscribe(result => {
        this.rubros = result;
        this.obtenerRubroSeleccionado();
        this.spinner.hide('spinnerGrafico')
        this.cargandoInfoProducto = false;
      }, () => this.errorRubros = true);
  }

  formatDensidad(event, i: number) {
    if (event.charCode == 8 || event.charCode == 0) return null;

    if (event.charCode >= 48 && event.charCode <= 57) {
      if (i == 0) {
        this.densidadMinima.setValue(this.sharedService.formatDensidad(event));
      } else {
        this.densidadMaxima.setValue(this.sharedService.formatDensidad(event));
      }
    }
    return false;
  }

  modificarProducto() {
    if (this.informacionForm.valid) {
      const p: Producto = new Producto();
      p.codigoProducto = this.codigo.value;
      this.modificandoProducto = true;
      p.nombreProducto = this.descripcion.value;
      p.unidadMedida = this.unidadDeMedida.value;
      p.tipoPrecio = this.tipoDePrecio.value;
      p.tipoCombustible = this.combustible.value;
      p.tipoAerocombustible = this.aerocombustible.value;
      p.tipoServicio = this.servicios.value;
      p.color = this.selectedColor;
      p.rubroId = this.tipoDeProducto.value.id;
      p.activo = this.activo.value;
      p.id = this.productoSeleccionado.id;
      //solo para aero
      p.densidadMin = parseFloat(this.densidadMinima.value);
      p.densidadMax = parseFloat(this.densidadMaxima.value);
      p.porcentajeAlije = Number(this.porcentajeAlije.value);
      //solo para combustible
      if (this.tipoDeProducto.value.aerocombustible) { p.tipoProducto = TipoProducto.Aerocombustible }
      if (this.tipoDeProducto.value.aeroespecialidad) { p.tipoProducto = TipoProducto.Aeroespecialidad }
      if (this.tipoDeProducto.value.combustible) { p.tipoProducto = TipoProducto.Combustible }
      if (this.tipoDeProducto.value.servicios) {
        p.tipoProducto = TipoProducto.Servicios;
        p.tipoServicio = this.servicios.value;
      }

      p.peligrosidad = this.peligrosidad.value;
      p.agrupacionContable = this.contable.value;
      p.partida = this.partida.value;
      p.productoSAP = this.productoSAP.value;
      p.unidadMedidaSAP = this.unidadSAP.value;
      p.unidadNegocioGerencial = this.negocioGerencial.value;
      p.unidadMedidaStock = this.unidadStock.value;
      p.unidadMedidaComercial = this.unidadComercial.value;
      p.unidadMedidaProduccion = this.unidadProduccion.value;
      p.grupoEnvase = this.grupoEnvase.value;
      p.controlCalidad = this.controlCalidad.value;
      p.controlStock = this.controlStock.value;
      p.aprobadoProducto = this.productoAprobado.value;
      p.contabilizaIATANivelDosTres = this.facturaClase3.value;
      p.aplicaITC = this.aplicaITC.value;
      p.aplicaIDC = this.aplicaIDC.value;
      p.aprobadoImpuestos = this.impuestoAprobado.value;
      p.codigoProductoSAPCompleto = this.codigoProductoSap.value;
      this.productoService.modificarProducto(p)
        .subscribe(() => {
          this.messageService.showSuccessMessage("Se ha modificado el producto correctamente");
          this.listaDeProductos.ngOnInit();
          this.modificandoProducto = false;
        }, (err: ErrorModel) => {
          this.messageService.showErrorMessage(err.message + '\n' + err.description);
          this.modificandoProducto = false;
        });
    }
    else {
      this.messageService.showErrorMessage('Por favor revise los campos a completar.');
      this.modificandoProducto = false;
    }
  }

  // validaciones
  densidadMenor() {
    if (parseFloat(this.densidadMinima.value) > parseFloat(this.densidadMaxima.value)) {
      this.densidadErronea = true;
    } else {
      this.densidadErronea = false;
    }
  }

  obtenerTipoCombustible(): string {
    return TipoCombustible[this.combustible.value];
  }

  obtenerTipoAerocombustible(): string {
    return TipoAerocombustible[this.aerocombustible.value];
  }

  onlyDecimalNumberKey(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  esCampoVacio(campo: any): boolean {

    return (campo == null || (campo != null && campo.length == 0));
  }

  campoInicializadoEnVacio(campo: any): boolean {

    return (campo != null && campo === '');
  }


  camposVacios() {
    return this.esCampoVacio(this.codigo.value) || this.esCampoVacio(this.descripcion.value);
  }


  esAerocombustible() {
    if (this.tipoDeProducto.value.aerocombustible) {
      this.esaero = true;
    } else {
      this.esaero = false;
    }
  }

  // form

  onChange(value) {
    this.selectedColor = value;
  }

  obtenerPosicionRubroSeleccionado(): number {
    let i = 0;
    i = this.rubros.findIndex(r => r.id == this.rubroSeleccionado.id);
    return i;
  }

  obtenerRubroSeleccionado() {
    this.productoService.getRubroPorId(this.productoSeleccionado.rubro.id)
      .subscribe(result => {
        this.rubroSeleccionado = result;
        const i = this.obtenerPosicionRubroSeleccionado();
        this.tipoDeProducto.setValue(this.rubros[i]);
        if (this.rubros[i].aerocombustible) {
          this.esaero = true;
          this.mostrarCampoTipoAerocombustible = true;
        } else {
          this.esaero = false;
          this.mostrarCampoTipoAerocombustible = false;
        }
        this.cargandoRubros = false;


        if(this.rubros[i].combustible){
          this.mostrarCampoTipoCombustible = true;
        }else{
          this.mostrarCampoTipoCombustible = false;
        }
        if(this.rubros[i].servicios){
          this.mostrarCampoTipoServicio = true;
        }else{
          this.mostrarCampoTipoServicio = false;
        }
      });
  }

  deshabilitarProducto() {
    if (this.productoSeleccionado.aprobadoProducto) {
      this.informacionForm.get('productoAprobadoFormControl')?.disable();
    } else {
      this.informacionForm.get('productoAprobadoFormControl')?.enable();
    }

  }

  deshabilitarImpuesto() {
    if (this.productoSeleccionado.aprobadoImpuestos) {
      this.informacionForm.get('impuestoAprobadoFormControl')?.disable();
    } else {
      this.informacionForm.get('impuestoAprobadoFormControl')?.enable();
    }
  }


  keysUnidadDeMedida(): Array<string> {
    const keys = Object.keys(this.unidadMedida);
    return keys.slice(keys.length / 2);
  }

  keysTipos(): Array<string> {
    let keys = Object.keys(this.tipoProducto);
    keys.shift();
    keys = keys.slice(keys.length / 2);
    keys.shift();
    return keys;
  }

  keysTipoPrecio(): Array<string> {
    const keys = Object.keys(this.tipoPrecio);
    return keys.slice(keys.length / 2);
  }

  keysTipoCombustible(): Array<string> {
    const keys = Object.keys(this.tipoCombustible);
    return keys.slice(keys.length / 2);
  }

  keysTipoAerocombustible(): Array<string> {
    const keys = Object.keys(this.tipoAerocombustible);
    return keys.slice(keys.length / 2);
  }

  keysTipoServicio(): Array<{ key: TipoServicio, description: string }> {
    return Object.values(TipoServicio)
      .filter(value => typeof value === 'number')
      .map(value => ({
        key: value as TipoServicio,
        description: TipoServicioUtil.getDescripcionPorClave(value as TipoServicio)
      }));
  }


  esAeroespecialidad() {
    return this.tipoDeProducto.value.aeroespecialidad;
  }

  esServicio() {
    return this.tipoDeProducto.value.servicios;
  }

  // getters

  obtenerUnidadMedida(unidad: number) {
    return UnidadMedida[unidad];
  }

  obtenerTipoPrecio(precio: number) {
    return TipoPrecio[precio];
  }

  obtenerCombustible(comb: number) {
    return TipoCombustible[comb];
  }

  obtenerAerocombustible(aerocomb: number) {
    return TipoAerocombustible[aerocomb];
  }

  obtenerServicio(servicio: string) {
    return TipoServicio[servicio];
  }

  get codigo() {
    return this.informacionForm.get('codigoFormControl');
  }
  get descripcion() {
    return this.informacionForm.get('descripcionFormControl');
  }
  get unidadDeMedida() {
    return this.informacionForm.get('unidadMedidaFormControl');
  }
  get tipoDeProducto() {
    return this.informacionForm.get('tipoProductoFormControl');
  }
  get densidadMaxima() {
    return this.informacionForm.get('densidadMaximaFormControl');
  }
  get densidadMinima() {
    return this.informacionForm.get('densidadMinimaFormControl');
  }
  get activo() {
    return this.informacionForm.get('activoFormControl');
  }
  get tipoDePrecio() {
    return this.informacionForm.get('tipoPrecioFormControl');
  }
  get combustible() {
    return this.informacionForm.get('tipoCombustibleFormControl');
  }
  get aerocombustible() {
    return this.informacionForm.get('tipoAerocombustibleFormControl');
  }
  get peligrosidad() {
    return this.informacionForm.get('peligrosidadFormControl');
  }
  get contable() {
    return this.informacionForm.get('contableFormControl');
  }
  get partida() {
    return this.informacionForm.get('partidaFormControl');
  }
  get productoSAP() {
    return this.informacionForm.get('productoSAPFormControl');
  }
  get unidadSAP() {
    return this.informacionForm.get('unidadSAPFormControl');
  }
  get negocioGerencial() {
    return this.informacionForm.get('negocioGerencialFormControl');
  }
  get unidadStock() {
    return this.informacionForm.get('unidadStockFormControl');
  }
  get unidadComercial() {
    return this.informacionForm.get('unidadComercialFormControl');
  }
  get unidadProduccion() {
    return this.informacionForm.get('unidadProduccionFormControl');
  }
  get grupoEnvase() {
    return this.informacionForm.get('grupoEnvaseFormControl');
  }
  get controlCalidad() {
    return this.informacionForm.get('controlCalidadFormControl');
  }
  get controlStock() {
    return this.informacionForm.get('controlStockFormControl');
  }
  get productoAprobado() {
    return this.informacionForm.get('productoAprobadoFormControl');
  }
  get facturaClase3() {
    return this.informacionForm.get('facturaIataFormControl');
  }
  get aplicaITC() {
    return this.informacionForm.get('aplicaITCFormControl');
  }
  get aplicaIDC() {
    return this.informacionForm.get('aplicatIDCFormControl');
  }
  get impuestoAprobado() {
    return this.informacionForm.get('impuestoAprobadoFormControl');
  }
  get codigoProductoSap() {
    return this.informacionForm.get('codigoProductoSapFormControl');
  }
  get porcentajeAlije() {
    return this.informacionForm.get('porcentajeAlijeFormControl');
  }
  get servicios() {
    return this.informacionForm.get('tipoServicioFormControl');
  }

  deshabilitarInput(...roles: TipoUsuario[]){
    if(this.authService.hasRole(...roles)){
      return false;
    }else{
      return true;
    }
  }
}
